//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import ItemId from '@models/ItemId';
import PartialCuid from '@models/PartialCuid';
import { UniversalItemType } from '@models/UniversalItemType';
import { ISelectedItem } from 'app/bulk-actions/model/ISelectedItem';

export const isBulkSelected = (
  selectedItems: ISelectedItem[],
  itemType: UniversalItemType,
  id: ItemId,
) => {
  const pcuid = PartialCuid.build({ itemType, id });
  const selectedCuids = selectedItems.map((si) => si.cuid);
  return selectedCuids.includes(pcuid);
};
